import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { generateImageLink } from '../../utils/design.utils';
import './SlideShow.css';

const SlideShow = props => {
  const { t } = useTranslation();
  const { srcSet, ...imageProps } = props;
  const [src, setSrc] = useState(srcSet[0]);
  const [sliding, setSliding] = useState(false);
  const indexRef = useRef(0);
  const slideShowTimer = useRef();
  const authToken = useSelector(state => state.authentication.user.authToken);

  useEffect(() => {
    return () => {
      if (slideShowTimer.current) clearInterval(slideShowTimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startSliding = () => {
    setSliding(true);
    if (srcSet.length > 1)
      slideShowTimer.current = setInterval(() => {
        indexRef.current += 1;
        setSrc(srcSet[indexRef.current % srcSet.length]);
      }, 2000);
  };

  const stopSliding = () => {
    if (slideShowTimer.current) {
      indexRef.current = 0;
      setSrc(srcSet[0]);
      clearInterval(slideShowTimer.current);
    }
    setSliding(false);
  };

  return (
    <div onMouseEnter={startSliding} onMouseLeave={stopSliding}>
      <img {...imageProps} alt={imageProps.alt || ''} src={generateImageLink(src, authToken)} loading="lazy" />

      {sliding && (
        <span className="slidePageCount">
          {`${(indexRef.current % srcSet.length) + 1} ${t('of')} ${srcSet.length}`}
        </span>
      )}
    </div>
  );
};

SlideShow.propTypes = {
  srcSet: PropTypes.arrayOf(PropTypes.string),
};

export default SlideShow;
